import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { useCustomTheme } from 'contexts/theme'
import { PropsWithChildren } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    width: '100%',
    minHeight: 'calc(100vh - 2.25rem)',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    overflow: 'hidden',

    '@media (max-height: 800px)': {
      minHeight: '115vh',
    },
  },

  base: {
    height: '100%',
    width: '100%',
    minHeight: '100vh',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    overflow: 'hidden',

    '@media (max-height: 800px)': {
      minHeight: '115vh',
    },
  },

  background: {
    backgroundColor: theme.palette.primary.dark,
  },
}))

interface WrapperPermissionProps extends PropsWithChildren {
  withBackground?: boolean
}

const WrapperPermission = ({ children, withBackground = false }: WrapperPermissionProps) => {
  const classes = useStyles()

  const { theme } = useCustomTheme()

  const bg = withBackground && classes.background

  if (theme.name !== 'default') {
    return <div className={clsx(classes.root, bg)}>{children}</div>
  }

  return <div className={clsx(classes.base, bg)}>{children}</div>
}

export default WrapperPermission
